// extracted by mini-css-extract-plugin
export default {"modalEditor":"ModalEditDoc_modalEditor__2YrV5"};